// extracted by mini-css-extract-plugin
export var csatScore = "_ma-5";
export var header = "_ma-1";
export var panelWrapper = "_ma-2";
export var postPreview = "_ma-3";
export var rightContent = "_ma-0";
export var wrappingText = "_ma-4";